import { ReactComponent as WarnIcon} from '../assets/icons/warning.svg';

export function DefaultError(params) {

    const refresh = () => {
        window.location.reload()
    }

    return (<section class="main-error">
        <div className="content">
            <WarnIcon />
            <h3>Lo sentimos, ocurrio un error inesperado.</h3>
            <h3>Favor de refrescar la página</h3>
            <button onClick={refresh}>Refrescar</button>
        </div>
    </section>)
}